import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';
  import Modal from '@/components/common/Modal.vue';
  import Loader from '@/components/common/Loader.vue';
  import { AccessRoles } from '@/types/api/roles';
  import { apiGetRoleAccess, apiSaveRoleAccess } from '@/api/roles';
  import { useToasted } from '@/helpers';
  import ToggleSwitch from '@/components/common/ToggleSwitch.vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';

  
  const __default__ = {
    name: 'PermissionsManagerModal',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    itemId: { type: [String, Number], required: true },
    type: { type: String, required: true }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    itemId: string | number;
    type: 'layout' | 'playlist' | 'playlistitem' | 'screen-groups' | 'screen' | 'templates';
  };

  

  const toasted = useToasted();

  

  const isLoading = ref<boolean>(false);
  const isSaving = ref<boolean>(false);
  const roles = ref<Array<AccessRoles>>([]);

  onMounted(async () => {
    isLoading.value = true;
    try {
      const response = await apiGetRoleAccess(props.itemId, props.type);
      roles.value = response.access_roles;
    } catch (err) {
      console.log('Failed to get roles access');
    }
    isLoading.value = false;
  });

  function close() {
    emit('close');
  }

  async function save() {
    isSaving.value = true;
    try {
      const access = roles.value.filter((role) => role.is_active).map((role) => role.id);
      await apiSaveRoleAccess(props.itemId, props.type, access);
      toasted.global.general_success({
        message: 'Role updated successfully',
      });
      close();
    } catch (err) {
      toasted.global.general_error({
        message: 'Error updating the role',
      });
    }
    isSaving.value = false;
  }

  const selectedRoles = computed({
    get() {
      const access: { [key: number]: boolean } = {};
      roles.value.forEach((role) => {
        access[role.id] = role.is_active;
      });
      return access;
    },
    set(newAccess: { [key: number]: boolean }) {
      roles.value.forEach((role) => {
        if (newAccess[role.id] !== undefined) {
          role.is_active = newAccess[role.id];
        }
      });
    },
  });

  function handlePermissionChange(roleId: number, value: boolean) {
    selectedRoles.value = {
      ...selectedRoles.value,
      [roleId]: value,
    };
  }

return { __sfc: true,props, toasted, emit, isLoading, isSaving, roles, close, save, selectedRoles, handlePermissionChange, Modal, Loader, ToggleSwitch, BaseText }
}

})